import listActions from 'src/modules/countryState/list/countryStateListActions';
import CountryStateService from 'src/modules/countryState/countryStateService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'COUNTRYSTATE_DESTROY';

const countryStateDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: countryStateDestroyActions.DESTROY_STARTED,
      });

      await CountryStateService.destroyAll([id]);

      dispatch({
        type: countryStateDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.countryState.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/country-state');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: countryStateDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: countryStateDestroyActions.DESTROY_ALL_STARTED,
      });

      await CountryStateService.destroyAll(ids);

      dispatch({
        type: countryStateDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.countryState.destroyAll.success'),
      );

      getHistory().push('/country-state');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: countryStateDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default countryStateDestroyActions;
